import { React, useState } from 'react';
// import { returnReceipt, setReceiptPrintCopy } from '../../actions/checks';
import classes from './NavReceiptsPostponed.module.css';
import {
  Button,
  Modal,
  Table,
  Accordion,
  InputGroup,
  FormControl,
  Container,
  Row,
  Col,
  Form,
  Stack
} from 'react-bootstrap';
import ReceiptsIcon from '../../../../../images/receipt-list-p.svg';
import Loader from '../../../../../images/loader.gif';
// import SearchIcon from '../../../../images/search-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useReceiptsPostponedList } from './hooks/useReceiptsPostponedList';
import { formatDate, formatMoney, formatWeight } from '../../../../../helpers/dataFormatter';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import DatePickerSelect from '../../../../ui/DatePickerSelect';

const NavReceiptsPostponed = (props) => {
  // const dispatch = useDispatch();
  const {
    delay,
    getPostponedReceipts,
    selectPostponedReceipt,
    modalShow,
    receiptsData,
    showLoader,
    filterDate,
    setModalShow,
  } = useReceiptsPostponedList();

  //
  return (
    <div>
      <Button
        className={`me-md-2 ${classes.button}`}
        size='sm'
        onClick={(e) => {
          e.target.parentElement.focus();
          e.target.parentElement.blur();
          setModalShow(true)
        }}
      >
        <img className={classes.nav_icon} src={ReceiptsIcon} alt='checklist' /> <div className={classes.icon_text}>Відкладені чеки</div>
      </Button>
      {modalShow && (
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size='xl'
          centered
          scrollable={true}
        // dialogClassName="modal-90w"
        // dialogClassName="customModal"
        >
          {showLoader === true && (
            <img
              className='position-absolute top-50 start-50 translate-middle'
              src={Loader}
              style={{ width: '50px' }}
              alt=''
            />
          )}
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>
              Відкладені чеки
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={classes.modal_body}>
            <Container>
              <Row>
                <Stack style={{ flexDirection: 'row' }}>
                  <DatePickerSelect
                    dateValue={filterDate}
                    onChange={(date) => {
                      getPostponedReceipts(date);
                    }}
                  />
                  <Button
                    variant="outline-secondary"
                    size="lg"
                    className="refresh-button"
                    onClick={() => getPostponedReceipts(filterDate)}
                    title="Оновити"
                    style={{ marginLeft: '3px', height: '42px', width: '53px', top: '1px' }}
                  >
                    <i className="bi bi-arrow-clockwise"></i>
                  </Button>
                </Stack>
                {/* </Col> */}
              </Row>
            </Container>

            <Accordion className='mt-1' flush>

              {receiptsData?.receipts &&
                receiptsData.receipts.length > 0 &&
                receiptsData.receipts.map((item) => {
                  return (
                    <Accordion.Item eventKey={'postponedList-' + item.id} key={'postponedList-' + item.id}>
                      <Accordion.Header className={classes.header} as='div'>
                        {`№${item.id} від  ${formatDate(item.date)}, ${formatMoney(item?.sumTotal ?? 0)}₴`}
                      </Accordion.Header>
                      <Accordion.Body className='p-0'>
                        <Table className={classes.table} size='sm'>
                          <thead>
                            <tr key={item.fiscalNumber}>
                              <th className='col-6'>Назва</th>
                              <th>К-сть</th>
                              <th>Ціна</th>
                              <th>Сума</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item?.products && item.products.map(
                              (checkProductItem) => {
                                return (
                                  <tr key={`${item.fiscalNumber}_${checkProductItem.id}`}>
                                    <td className={classes.td}>
                                      {checkProductItem.name}
                                    </td>
                                    <td className={classes.td}>
                                      {formatWeight(checkProductItem.count)}
                                    </td>
                                    <td className={classes.td}>
                                      {formatMoney(checkProductItem.price)}
                                    </td>
                                    <td className={classes.price}>
                                      {formatMoney(checkProductItem.sum)} грн
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </Table>
                        {item?.receiptSfr &&
                          <Table className={classes.table} size='sm'>
                            <thead>
                              <tr key={item.fiscalNumber}>
                                <th className='col-6'>Назва (ПРРО)</th>
                                <th>К-сть</th>
                                <th>Ціна</th>
                                <th>Сума</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item?.receiptSfr && item.receiptSfr.products.map(
                                (checkProductItem) => {
                                  return (
                                    <tr key={`${item.fiscalNumber}_${checkProductItem.id}`}>
                                      <td className={classes.td}>
                                        {checkProductItem.name}
                                      </td>
                                      <td className={classes.td}>
                                        {formatWeight(checkProductItem.count)}
                                      </td>
                                      <td className={classes.td}>
                                        {formatMoney(checkProductItem.price)}
                                      </td>
                                      <td className={classes.price}>
                                        {formatMoney(checkProductItem.sum)} грн
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </Table>

                        }
                        <Button
                          className='ms-2 mb-2'
                          size='sm'
                          variant='outline-secondary'
                          onClick={(event) => {
                            selectPostponedReceipt(item.id);
                          }}
                        >
                          Вибрати
                        </Button>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
            </Accordion>
          </Modal.Body>
        </Modal>
      )
      }
    </div >
  );
};

export default NavReceiptsPostponed;
